var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSelectOneSvg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 57L1 38.5C1 35.1863 3.68629 32.5 7 32.5L219.25 32.5M437.5 57L437.5 38.5C437.5 35.1863 434.814 32.5 431.5 32.5L219.25 32.5M219.25 32.5L219.25 9.54001e-06",
    stroke: "#eaeae9"
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSelectOneSvg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/select-one-svg.153190c1.svg";
export { ForwardRef as ReactComponent };